export const userPrivacyOptions = [
  {
    value: "Live",
    title: "Live",
    description: "Show your current location in real time."
  },
  {
    value: "Pinned",
    title: "Pinned",
    description: "Manually pin a location to your profile."
  },
  // {
  //   value: "Friends",
  //   title: "Friends Only",
  //   description: "Only visible to approved friends."
  // },
  {
    value: "Hidden",
    title: "Hidden",
    description: "Completely hide your profile from others."
  }
];